<script setup lang="ts">
import { useClipboard } from '@vueuse/core';
import { ref } from 'vue';
import { DocumentDuplicateIcon } from '@heroicons/vue/24/outline';

const props = defineProps<{
  correlationId?: string;
}>();
const currentTime = new Date().toUTCString();
const correlationId = ref(`${props.correlationId} ${currentTime}`);
const {
  copy,
  isSupported: isClipboardSupported,
  copied,
} = useClipboard({ source: () => correlationId.value });

function copyToClipboard() {
  copy(correlationId.value);
}
</script>

<template>
  If the issue persists,
  <a href="https://help.immersve.com" class="underline" target="_blank">contact our support team</a>
  <span v-if="props.correlationId">
    and reference {{ correlationId }}
    <button @click="copyToClipboard" v-if="isClipboardSupported" class="inline-block">
      <DocumentDuplicateIcon class="size-4" />
    </button>
    <span v-if="copied" class="absolute">Copied!</span>
  </span>
</template>
